var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24PxRolePlayingEmotions01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-role-playing-emotions-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,1H9V7H1V17.5c0,2,4.12,4.24,6.57,5.4l.43.21.43-.21C10.88,21.74,15,19.49,15,17.5v-.77h0l1,.56,1-.56c4-2.27,6-4.37,6-6.24V1ZM13,17.45c-.17.62-2.46,2.19-5,3.44-2.54-1.25-4.83-2.81-5-3.39V9H9v1.5c0,1.52,1.36,3.19,4,5Zm8-6.95c0,1.66-5,4.5-5,4.5s-5-2.84-5-4.5V3H21ZM12.5,6A1.5,1.5,0,1,1,14,7.5,1.5,1.5,0,0,1,12.5,6Zm4,0A1.5,1.5,0,1,1,18,7.5,1.5,1.5,0,0,1,16.5,6Zm-4.23,4,2-.45A1.87,1.87,0,0,0,16,11a1.85,1.85,0,0,0,1.77-1.47l2,.44a3.81,3.81,0,0,1-7.46,0ZM4.5,12A1.5,1.5,0,1,1,6,13.5,1.5,1.5,0,0,1,4.5,12ZM8,14.75a3.86,3.86,0,0,1,3.73,3l-2,.44A1.85,1.85,0,0,0,8,16.75a1.85,1.85,0,0,0-1.77,1.47l-2-.44A3.86,3.86,0,0,1,8,14.75Z",
    fill: "#242f47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24PxRolePlayingEmotions01);
export default __webpack_public_path__ + "static/media/24px-role-playing-emotions-01.9f027ab2122b6de315a786839828d026.svg";
export { ForwardRef as ReactComponent };